export enum WarningLevel {
    Success = 1,
    Warning = 2,
    Error = 3,
    Info = 4,
    Question = 5,
}